export const nameToId = (name: string): string => {
  let id = name.toLowerCase().replace(/ /g, "-")
  return id
}
